import React, { useEffect, useState,useRef, useCallback  } from 'react'
import { Breadcrumb, CardBasic, PaginationCustom, SButton, TextInput, ModalForm } from '../../components'
import Select from 'react-select';
import {Link, useLocation, useNavigate } from 'react-router-dom';
import { Ceklis } from '../../assets';
import { API_BASE_URL } from '../../config';
import { useSelector } from 'react-redux';
import ShowAlert from '../../components/ShowAlert';


function Patient() {
    const [selectedStatus, setSelectedStatus] = useState({label: 'All',value: 'All'});
    const [searchTerm, setSearchTerm] = useState('');
  
    const [apiData, setApiData] = useState([]);
    const [newData, setNewData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);

    const [therapisOpt, setTherapisOpt] = useState([]);
    const [treatmentOpt, setTreatmentOpt] = useState([]);
    const [room, setRoom] = useState([]);
    
    const [showNotif, setShowNotif] = useState(false);
    const [notifType, setNotifType] = useState('success');
    const [notifMessage, setNotifMessage] = useState('Form has been successfully submitted!');
    

    const user = useSelector((state) => state.auth);
    const location = useLocation();
    const navigate = useNavigate();

    const arr = [
        {label: 'All',value: 'All'},
        {label: 'Receipt',value: 'Receipt'},
        {label: 'Refund',value: 'Refund'},
        {label: 'Being Handled',value: 'Being Handled'},
        {label: 'Canceled',value: 'Canceled'}
    ];

    const handleStatusChange = (selectedOption) => {
        setSelectedStatus(selectedOption);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // const handleCreate = () => {
    //     navigate('create')
    // };

    const normalizeDate = (date) => {
        const normalized = new Date(date);
        normalized.setHours(0, 0, 0, 0); // Set time to 00:00:00
        return normalized;
    };

    const fetchData = useCallback(async () => {
            setIsLoading(true);
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/patient_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );
                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data!');
                    return;
                }
                const data = await res.json();
                setApiData(data);
            } catch (error) {
                if (window.confirm('Gagal mengambil data. Coba lagi?')) {
                    fetchData();
                }
            } finally {
                setIsLoading(false);
            }
    }, [user.user.klinik_id]);

    useEffect(() => {
        fetchData();
    },[fetchData]);

    useEffect(() => {
        const filterByDateAndStatus = (data = []) => {
            const filteredData = data.filter((item) => {
                const statusMatch = selectedStatus.value === 'All' || item.status === selectedStatus.value; // Filter by status
                const searchMatch = searchTerm.trim() === "" || item.patient.toLowerCase().includes(searchTerm.toLowerCase()); // Filter by search term
                return statusMatch && searchMatch;
            });

            const sortedData = filteredData.sort((a, b) => {
                const dateA = new Date(normalizeDate(a.date));
                const dateB = new Date(normalizeDate(b.date));
                return dateA - dateB; // Ascending order
            }); 

            return sortedData;
        };
        
        const filteredAndSortedData  = filterByDateAndStatus(apiData.data);
        setNewData(filteredAndSortedData );
    }, [apiData,selectedStatus,searchTerm]);

    useEffect(() => {
        const fetchTreatment = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/master_treatment_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );

                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data!');
                    return;
                }
                const treatment = await res.json();                   

                setTreatmentOpt(
                    Array.isArray(treatment.data)
                        ? treatment.data.map(item => ({
                            value: item.id || item.value,
                            label: item.treatment_name || item.label,
                        }))
                        : []
                );
            } catch (error) {
                console.error("Error fetching treatment:", error);
            }
        };
    
        const fetchTherapis = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/employee_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );

                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data!');
                    return;
                }
                const therapists = await res.json(); 
                
                const filterTherapis =  Array.isArray(therapists.data) ? 
                    therapists.data.filter((item) => item.role === 1 || item.role === 3).map(item => ({
                        value: item.id || item.value,
                        label: item.full_name || item.label,
                    })) : [];

                setTherapisOpt(
                    filterTherapis
                );
            } catch (error) {
                console.error("Error fetching therapis:", error);
            }
        };
    
        const fetchRooms = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/room_get_klinik/${user.user.klinik_id}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        }
                    }
                );
                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    console.log(errorData.message || 'Gagal mengambil data!');
                    return;
                }
                const rooms = await res.json();
            
                setRoom(
                    Array.isArray(rooms.data)
                        ? rooms.data.map(item => ({
                            value: item.id || item.value,
                            label: item.name_room || item.label,
                        }))
                        : []
                );
            } catch (error) {
                console.error("Error fetching room:", error);
            } 
        }
    
        fetchTherapis();
        fetchTreatment();
        fetchRooms();
    },[user.user.klinik_id]);


    const CardTitle = () => {
        // const Added = () => {
        //     return (
        //         <>
        //             <i className="ki-outline ki-plus fs-2"></i>Patients
        //         </>
        //     )
        // }

        return (
            <>
                <div className='card-title'>
                    <div className="d-flex align-items-center position-relative my-1">
                        <i className="ki-outline ki-magnifier fs-3 position-absolute ms-4"></i>
                        <TextInput type={'text'} 
                        clas={'form-control form-control-solid w-250px ps-12'}
                        placeholder={'Search Patient'}
                        value={searchTerm}
                        onChange={handleSearchChange}
                        />
                    </div>
                </div>
                <div className='card-toolbar flex-row-fluid justify-content-end gap-5'>
                    <div className="w-150px">
                        <Select
                            className=""
                            options={arr}
                            placeholder="Status"
                            isSearchable={false}
                            value={selectedStatus}
                            onChange={handleStatusChange}
                        />
                    </div>
                
                    {/* <div>
                        <SButton
                            className={"btn btn-light-primary"}
                            children={<Added/>}
                            action={handleCreate}
                        />
                    </div> */}
                </div>
            </>
        )
    }

    const ListBody = ({arr}) => {
        const [activeIndex, setActiveIndex] = useState(null);
        const [filteredData, setFilteredData] = useState([]);
        const [showModal, setShowModal] = useState(false);
        const [currentData, setCurrentData] = useState([]);

        // const [showCancelModal, setShowCancelModal] = useState(false);
        // const [selectedUser, setSelectedUser] = useState(null);
        const [fields, setFields] = useState([]);

        const [showModalRegist, setShowModalRegist] = useState(false);
        const [showRegistModal, setShowRegistModal] = useState(false);

        const [showModalAppointment, setShowModalAppointment] = useState(false);

        const dropdownRef = useRef([]);


        //Toogle Button
        const toggleAction = (index) => {
            setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
        };

        // Menutup dropdown jika klik di luar
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (
                    activeIndex !== null &&
                    dropdownRef.current[activeIndex] &&
                    !dropdownRef.current[activeIndex].contains(event.target)
                ) {
                    setActiveIndex(null);
                }
            };

            document.addEventListener("click", handleClickOutside);
            return () => {
                document.removeEventListener("click", handleClickOutside);
            };
        }, [activeIndex]);

        const handlePagination = useCallback((data) => {
            setFilteredData((prevData) => {
                // Hanya setState jika data berbeda
                if (JSON.stringify(prevData) !== JSON.stringify(data)) {
                    return data;
                }
                return prevData;
            });
        }, []);

        const actions = () => {
            return (
                <>
                    <i className="ki-outline fs-2"></i>Actions
                </>
            )
        }

        const handleEditModal  = (item) => {

            const genderOpt = [ 
                {
                    label: 'Male',
                    value: 'Male'
                },
                {
                    label: 'Female',
                    value: 'Female'
                }
            ]

            const maritalOpt = [ 
                {
                    label: 'Belum Menikah',
                    value: 'Belum Menikah'
                },
                {
                    label: 'Menikah',
                    value: 'Menikah'
                }
            ]

            const memberOpt = [ 
                {
                    label: 'No Member',
                    value: 'No Member'
                },
                {
                    label: 'Platinum',
                    value: 'Platinum'
                }
            ]

            const selectedGender = genderOpt.find(opt => opt.value === item.gender) || { value: item.gender || '', label: `Unknown` };
            const selectedMarital = maritalOpt.find(opt => opt.value === item.martial_status) || { value: item.martial_status || '', label: `Selected Marital` };
            const selectedMember = memberOpt.find(opt => opt.value === item.member_type) || { value: item.member_type || '', label: `Selected Member` };

            setCurrentData({
                id: item.id,
                full_name: item.full_name,
                no_medical_record: item.no_medical_record,
                email: item.email,
                date_of_birth: item.date_of_birth,
                place_of_birth: item.place_of_birth,
                phone_number: item.phone_number,
                identity_number: item.identity_number,
                gender: selectedGender,
                member_type: selectedMember,
                martial_status: selectedMarital,
                religion: item.religion,
            });

            setFields(
                [
                    { type: 'hidden', name: 'id', label: '_ids',classLabel: 'form-label' ,placeholder: '', value: item.id || '', className: '',disable: true,required: false},
                    { type: 'text', name: 'no_medical_record', label: 'No. Medical Record',classLabel: 'form-label' ,placeholder: 'Enter name', value: item.no_medical_record || '', className: '',disable: true,required: true, column: 'col-6'},
                    { type: 'text', name: 'identity_number', label: 'Identity Number', classLabel: 'form-label',value:  item.identity_number || '', className: '',disable: false,onlyNumber: true,required: true,column: 'col-6'},
                    { type: 'text', name: 'full_name', label: 'Full Name', classLabel: 'form-label',value:  item.full_name || '', className: '',disable: false,required: true,column: 'col-12'},
                    { type: 'text', name: 'phone_number', label: 'No. Telephone', classLabel: 'form-label',value: item.phone_number || '', className: '',disable: false,required: true,onlyNumber: true,column: 'col-6'},
                    { type: 'text', name: 'email', label: 'Email', classLabel: 'form-label',value: item.email || '', className: '',disable: false,required: true,column: 'col-6'},
                    { type: 'text', name: 'place_of_birth', label: 'Place Of Birth', classLabel: 'form-label',value:  item.place_of_birth || '', className: '',disable: false,required: true,column: 'col-6'},
                    { type: 'date', name: 'date_of_birth', label: 'Date Of Birth', classLabel: 'form-label',value: item.date_of_birth || '', className: '',disable: false,required: true,column: 'col-6'},
                    { type: 'select', name: 'gender', label: 'Gender',classLabel: 'form-label' ,options: genderOpt, placeholder: 'Select Gender', value:  selectedGender, className: '',disable: false,required: true,column: 'col-6'  },
                    { type: 'select', name: 'martial_status', label: 'Marital Status',classLabel: 'form-label' ,options: maritalOpt, placeholder: 'Select Marital', value: selectedMarital, className: '',disable: false,required: true ,column: 'col-6' },
                    { type: 'text', name: 'religion', label: 'Religion', classLabel: 'form-label',value: item.religion || '', className: '',disable: false,required: true,column: 'col-6'},
                    { type: 'select', name: 'member_type', label: 'Type Member',classLabel: 'form-label' ,options: memberOpt, placeholder: 'Select Member', value: selectedMember , className: '',disable: false,required: true ,column: 'col-6' },
                ]
            )
            
            setShowModal(true); 
        }

        const handleCloseModal = () => {
            setShowModal(false);
        };

        const handleCloseConfirm = () => {
            setShowNotif(false);

            // Navigasi setelah notifikasi ditutup
            const basePath = location.pathname.split('/')[1];
            navigate(`/${basePath}`);
        };

        const formatDateYMD = (date) => {
            if (!date) return '';
            const d = new Date(date);
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        };

        const handleSaveModal = async (updatedData) => {
                const updPatient = {
                    full_name: updatedData?.full_name,
                    date_of_birth: formatDateYMD(updatedData?.date_of_birth),
                    email: updatedData?.email,
                    identity_number: updatedData?.identity_number,
                    no_medical_record: updatedData?.no_medical_record,
                    phone_number: updatedData?.phone_number,
                    place_of_birth: updatedData?.place_of_birth,
                    religion: updatedData?.religion,
                    gender: Array.isArray(updatedData?.gender) 
                        ? updatedData?.gender.map(item => item.value || item) // Simpan sebagai array of IDs jika multiselect
                        : updatedData?.gender?.value || updatedData?.gender || null, // Simpan sebagai ID saja jika single select
                    martial_status: Array.isArray(updatedData?.martial_status) 
                        ? updatedData?.martial_status.map(item => item.value || item) 
                        : updatedData?.martial_status?.value || updatedData?.martial_status || null,
                    member_type: Array.isArray(updatedData?.member_type) 
                        ? updatedData?.member_type.map(item => item.value || item) 
                        : updatedData?.member_type?.value || updatedData?.member_type || null,
                    updated_by: user.user.id,
                };

                setLoadingSave(true);
                
                try {
                    const token = localStorage.getItem('access_token');
                    const res = await fetch(`${API_BASE_URL}/auth/patient/${updatedData.id}`, {
                        method: 'PATCH',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        },
                        body: JSON.stringify(updPatient)
                    });

                    if (!res.ok) {
                        const errorData = await res.json().catch(() => ({}));
                        console.log(errorData.message || 'Gagal update data!');
                        setLoadingSave(false);
                        return;
                    }

                    fetchData();
                } catch (error) {
                    alert('Terjadi kesalahan koneksi!');
                } finally {
                    setShowModal(false);
                    setLoadingSave(false);
                }
        }

        const handleCloseModalRegist = () => {
            setShowModalRegist(false);
        };


        const handleRegistModal = async (item) => {
            const selectedTherapis = therapisOpt.find(opt => Number(opt.value) === Number(item.therapist)) ||  { value: item.therapist || '', label: `Select a Therapist` };
            const selectedTreatment = treatmentOpt.find(opt => Number(opt.value) === Number(item.treatment)) ||  { value: item.treatment || '', label: `Select a Treatment` };

           
            setCurrentData({
                id: item.id,
                no_medical_record: item.no_medical_record,
                full_name: item.full_name,
                phone_number: item.phone_number,
                notes: item.notes || '',
                klinik_id: user.user.klinik_id,
                doctor_id: selectedTherapis ? selectedTherapis.value : '', 
                treatment: selectedTreatment ? selectedTreatment.value : '', 
                room_id: item.room_id || '',
            });

            setFields(
                [
                    { type: 'hidden', name: 'id', label: '_ids',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'hidden', name: 'no_medical_record', label: 'Medical Record',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'hidden', name: 'full_name', label: 'Full Name',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'hidden', name: 'phone_number', label: 'Phone Number',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'hidden', name: 'notes', label: 'notes',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'select', name: 'doctor_id', label: 'Therapis', classLabel: 'form-label', options: therapisOpt,placeholder: 'Select a Therapist', value: selectedTherapis ? selectedTherapis.value : '', className: '',disable: false,required: true  },
                    { type: 'select', name: 'treatment', label: 'Treatment',classLabel: 'form-label' ,options: treatmentOpt, placeholder: 'Select a Treatment', value: selectedTreatment ? selectedTreatment.value : '', className: '',disable: false,required: true  },
                    { type: 'select', name: 'room_id', label: 'Room',classLabel: 'form-label' ,options: room,placeholder: 'Select a Room', value: '', className: '',disable: false,required: true,  },
                ]
            )

            setShowModalRegist(true); 
        }

        const handleSaveRegist = async (updatedData,data) => {
            if (!updatedData || !data) {
                setNotifType('danger');
                setNotifMessage('Data tidak lengkap untuk melakukan registrasi!');
                setShowNotif(true);
                console.error("Missing data to update.");
                return;
            }
            setLoadingSave(true);

            const newRegistration = {
                full_name: currentData?.full_name,
                no_medical_record: updatedData?.no_medical_record,
                no_appointment: updatedData?.no_appointment ? updatedData?.no_appointment : '',
                treatment: updatedData?.treatment,
                kd_employee: '',
                doctor: updatedData?.doctor_id,
                room_id: updatedData?.room_id,
                notes: currentData?.notes,
                created_by: user.user.permission.id_user,
                klinik_id: user.user.pemilik[0].klinik_id,
                status: 'Receipt',
                created_at: new Date().toISOString().split('T')[0],
            };

            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/registration/create`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        },
                        body: JSON.stringify(newRegistration)
                    }
                );

                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    setNotifType('danger');
                    setNotifMessage(errorData.message || 'Gagal membuat data registrasi!');
                    setShowNotif(true);
                    setShowModalRegist(false); 
                    setLoadingSave(false);
                    return;
                }

                fetchData();
                setNotifType('success');
                setNotifMessage('Registrasi dan konfirmasi berhasil!');
            } catch (error) {
                setNotifType('danger');
                setNotifMessage('Terjadi kesalahan koneksi!');
                setShowNotif(true);
                setShowRegistModal(false);
                setShowModalRegist(false); 
                setLoadingSave(false);
            } finally {
                setShowNotif(true);
                setShowRegistModal(false);
                setShowModalRegist(false); 
                setLoadingSave(false);
            }
        }
        
        const handleAppointmentModal = (item) => {
            const selectedTherapis = therapisOpt.find(opt => Number(opt.value) === Number(item.therapist)) ||  { value: item.therapist || '', label: `Select a Therapist` };
            const selectedTreatment = treatmentOpt.find(opt => Number(opt.value) === Number(item.treatment)) ||  { value: item.treatment || '', label: `Select a Treatment` };
            let date = new Date();
            
            setCurrentData({
                id: item.id,
                no_medical_record: item.no_medical_record,
                full_name: item.full_name,
                phone_number: item.phone_number,
                email: item.email || '',
                notes: item.notes || '',
                appointment_date:  item.appointment_date, 
                appointment_time: item.appointment_time || date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
                doctor_id: selectedTherapis ? selectedTherapis.value : '', 
                treatment: selectedTreatment ? selectedTreatment.value : '',
            });

            setFields(
                [
                    { type: 'hidden', name: 'id', label: '_ids',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'hidden', name: 'no_medical_record', label: 'Medical Record',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'hidden', name: 'full_name', label: 'Full Name',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'hidden', name: 'phone_number', label: 'Phone Number',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'hidden', name: 'email', label: 'Email',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: true,required: false},
                    { type: 'datepicker', name: 'appointment_date', label: 'Appointment Date',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: false,required: true},
                    { type: 'timepicker', name: 'appointment_time', label: 'Appointment Time',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: false,required: true},
                    { type: 'select', name: 'doctor_id', label: 'Therapis', classLabel: 'form-label', options: therapisOpt,placeholder: 'Select a Therapist', value: selectedTherapis ? selectedTherapis.value : '', className: '',disable: false,required: true  },
                    { type: 'select', name: 'treatment', label: 'Treatment',classLabel: 'form-label' ,options: treatmentOpt, placeholder: 'Select a Treatment', value: selectedTreatment ? selectedTreatment.value : '', className: '',disable: false,required: true  },
                    { type: 'textarea', name: 'notes', label: 'Notes',classLabel: 'form-label' ,placeholder: '', value: '', className: '',disable: false,required: true},
                ]
            )

            setShowModalAppointment(true); 
        }

        const handleCloseModalAppointment = () => {
            setShowModalAppointment(false);
        }

        const handleSaveAppointment = async (updatedData) => {
            const today = new Date().toISOString().split('T')[0];
            if (!updatedData) {
                setNotifType('danger');
                setNotifMessage('Data tidak lengkap untuk membuat janji temu!');
                setShowNotif(true);
                console.error("Missing data to update.");
                return;
            }

            setLoadingSave(true);

            const newAppointment = {
                full_name: updatedData?.full_name,
                no_medical_record: updatedData?.no_medical_record,
                phone_number: updatedData?.phone_number,
                email: updatedData?.email,
                treatment: updatedData?.treatment,
                doctor_id: updatedData?.doctor_id,
                appointment_date: updatedData?.appointment_date || today,
                appointment_time: updatedData?.appointment_time,
                notes: updatedData?.notes,
                arrival_status: 'Pending',
                created_by: user.user.id,
                klinik_id: user.user.klinik_id,
            };

            try {
                const token = localStorage.getItem('access_token');
                const res = await fetch(
                    `${API_BASE_URL}/auth/appointment/create`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token && { Authorization: `Bearer ${token}` }),
                        },
                        body: JSON.stringify(newAppointment)
                    }
                );

                if (!res.ok) {
                    const errorData = await res.json().catch(() => ({}));
                    setNotifType('danger');
                    setNotifMessage(errorData.message || 'Gagal membuat janji temu!');
                    setShowNotif(true);
                    setShowModalAppointment(false); 
                    setLoadingSave(false);
                    return;
                }

                fetchData();
                setNotifType('success');
                setNotifMessage('Janji temu berhasil dibuat!');
            } catch (error) {
                setNotifType('danger');
                setNotifMessage('Terjadi kesalahan koneksi!');
                setShowNotif(true);
            } finally {
                setShowModalAppointment(false); 
                setLoadingSave(false);
            }
        }
        
        return (
            <>
                <div className="table-responsive">
                    <table className="table align-middle table-row-dashed fs-6 gy-5">
                        <thead>
                            <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                <th className="min-w-100px">ACTIONS</th>
                                <th className="min-w-100px">NAME PATIENT</th>
                                <th className="min-w-100px">NO MR</th>
                                <th className="min-w-100px">PHONE NUMBER</th>
                                <th className="min-w-100px">NO IDENTITY</th>
                                <th className="min-w-75px">GENDER</th>
                                <th className="min-w-75px">MEMBER TYPE</th>
                                <th className="min-w-100px">LAST TREATMENT</th>
                            </tr>
                        </thead>
                        <tbody className="fw-semibold text-gray-600">
                            {filteredData.map((item, index) => (
                                <tr key={index}>
                                    <td ref={(el) => (dropdownRef.current[index] = el)}>
                                        <SButton
                                         className={"btn btn-light-secondary"}
                                         children={actions()}
                                         action={() => toggleAction(index)}
                                        />

                                        {activeIndex === index && (
                                            <div  
                                                id={`dropdown-${index}`}
                                                className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-200px py-4"
                                                style={{
                                                    display: "block",
                                                    position: "absolute",
                                                    zIndex: 1000,
                                                }}
                                            >
                                               <div className="menu-item px-3">
                                                    <SButton
                                                        className={'menu-link px-3 w-100'}
                                                        variant={'transparent'}
                                                        size={'sm'}
                                                        action={() => navigate('/package-history',{
                                                            state: {
                                                                ...item,
                                                                from: [
                                                                    {label: 'Patient', path: '/patient'},
                                                                    {label: 'Package History', path: '/package-history' },
                                                                ]
                                                            }
                                                        })}    
                                                    >
                                                        Package History
                                                    </SButton>
                                                </div>
                                                <div className="menu-item px-3">
                                                    <SButton
                                                        className={'menu-link px-3 w-100'}
                                                        variant={'transparent'}
                                                        size={'sm'}
                                                        action={() => {
                                                            setActiveIndex(null); 
                                                            handleAppointmentModal(item);
                                                        }}
                                                    >
                                                        Appointment
                                                    </SButton>
                                                </div>
                                                <div className="menu-item px-3">
                                                    <SButton
                                                        className={'menu-link px-3 w-100'}
                                                        variant={'transparent'}
                                                        size={'sm'}
                                                        action={() => {
                                                            setActiveIndex(null); 
                                                            handleRegistModal(item);
                                                        }}
                                                    >
                                                        Registration
                                                    </SButton>
                                                </div>
                                                <div className="menu-item px-3">
                                                    <SButton
                                                        className={'menu-link px-3 w-100'}
                                                        variant={'transparent'}
                                                        size={'sm'}
                                                        action={() => {
                                                            setActiveIndex(null); 
                                                            handleEditModal(item)
                                                        }}
                                                    >
                                                        Edit
                                                    </SButton>
                                                </div>
                                            </div>
                                        )}
                                    </td>
                                    <td>
                                        <Link 
                                           to={`/doctor-review?id=${item._id}`}
                                           state={{
                                                ...item,
                                                from: [
                                                    {label: 'Patient', path: '/patient'},
                                                    {label: 'Doctor Review', path: '/doctor-review' },
                                                ]
                                            }}
                                        >{item.full_name}</Link>
                                    </td>
                                    <td >{item.no_medical_record}</td>
                                    <td >{item.phone_number}</td>
                                    <td >{item.identity_number}</td>
                                    <td>{item.gender}</td>
                                    <td>  
                                        <div className={ item.type_member === 'Platinum' ? `badge badge-light-primary` : 'badge badge-light-primary' }>
                                            {item.type_member ? item.type_member : '-'}
                                        </div>
                                    </td>
                                    <td>-</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <PaginationCustom
                        data={arr || []}
                        page={10}
                        current={1}
                        onPaginate={handlePagination}
                    />
                    {showModal && currentData && (
                        <ModalForm
                            show={showModal}
                            handleClose={handleCloseModal}
                            data={currentData}
                            formDatas={fields}
                            title={'Edit Patient'}
                            handleSave={handleSaveModal}
                        />
                    )}
                    { showNotif && (
                        <ShowAlert 
                            title={notifType === 'success' ? 'Ok, got it!' : 'Oops!'}
                            message={notifMessage}
                            pic={notifType === 'success' ? Ceklis : undefined}
                            show={showNotif} 
                            setShow={setShowNotif}
                            onClose={handleCloseConfirm}
                            swal={notifType === 'success' ? 'swal2-success' : 'swal2-danger'}
                        />
                    )}
                    {showModalRegist && currentData && (
                        <ModalForm
                            show={showModalRegist}
                            handleClose={handleCloseModalRegist}
                            data={currentData}
                            formDatas={fields}
                            title={'Registration'}
                            handleSave={handleSaveRegist}
                            btnLabel={'Register'}
                        />
                    )}
                    {showModalAppointment && currentData && (
                        <ModalForm
                            show={showModalAppointment}
                            handleClose={handleCloseModalAppointment}
                            data={currentData}
                            formDatas={fields}
                            title={'Appointment'}
                            handleSave={handleSaveAppointment}
                            btnLabel={'Book Appointment'}
                        />
                    )}
                  
                </div>
            </>
        )
    }

    return (
        <>
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
                <Breadcrumb title={'Home'} header={'Data All Patients'}/>
                <div className='app-container container-xxl d-flex'>
                    <div className='app-main flex-column flex-row-fluid' id="kt_app_main">
                        <div className='d-flex flex-column flex-column-fluid'>
                            <div className='app-content'>
                                {isLoading ? (
                                    <CardBasic
                                        className={'card-flush'}
                                        className3={'align-items-center py-5 gap-2 gap-md-5'}
                                        header={CardTitle()}
                                        className2={'pt-0'}
                                    >
                                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
                                            <div className="spinner-border text-primary" role="status"></div>
                                        </div>
                                    </CardBasic> 
                                ) : (
                                    <CardBasic
                                        className={'card-flush'}
                                        className3={'align-items-center py-5 gap-2 gap-md-5'}
                                        header={CardTitle()}
                                        className2={'pt-0'}
                                        children={
                                        <ListBody 
                                            arr={newData} 
                                            fetchData={fetchData}
                                        />
                                        }
                                    /> 
                                ) }
                            </div>
                        </div>
                        <div className='app-footer d-flex flex-column flex-md-row flex-center flex-md-stack pb-3'>
                            <div className='text-dark order-2 order-md-1'>
                                <span className='text-muted fw-semibold me-1'>2025&copy;</span>
                            </div>
                            <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
                                <li className='menu-item'><span className='menu-link px-2'>About</span></li>
                                <li className='menu-item'><span className='menu-link px-2'>Support</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {loadingSave && (
                <div
                    style={{
                    position: 'fixed',
                    zIndex: 2000,
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(255,255,255,0.6)',
                    backdropFilter: 'blur(2px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                    }}
                >
                    <div className="spinner-border text-primary" role="status" style={{ width: 60, height: 60 }}></div>
                </div>
            )}
        </>
    )
}

export default Patient
